module.exports = __webpack_public_path__ + "static/media/magnifier.d79e9cc5.svg";